var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Ene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:gray;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.6,142.13l138.98-.62c.29,0,.58-.01.86-.04,8.31-.74,10.77-11.85,3.83-16.48l-48.31-32.23,11.37-56.95c1.63-8.18-7.96-14.29-14.36-8.94-.22.18-.43.38-.64.58L7.62,125.3c-6.26,6.2-1.84,16.87,6.97,16.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 167,
    height: 167
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Ene);
export default __webpack_public_path__ + "static/media/3-ene.217471b50c327ab824ccf8e145463ebd.svg";
export { ForwardRef as ReactComponent };